import Wrapper from "../../../layout/Wrapper";
import ApproveVehicleInsuranceComponent from "../../../screens/approveds/vehicle-insurance";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Approved Life Insurance",
	description: "",
};

export default function ApproveLifeInsurance() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ApproveVehicleInsuranceComponent />
		</Wrapper>
	);
}